
import { ReportsActionTypes, ReportsActionsUnion } from '@core/actions/reports.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ProformaActionTypes, ProformaActionsUnion } from '@core/actions/proforma.actions';


export interface State {
  busy: boolean;
  message: string;
}

export const INITIAL_STATE: State = {
  busy: false,
  message: null,
};

export function reducer(
  state: State = INITIAL_STATE,
  action: ReportsActionsUnion | ProformaActionsUnion
) {
  switch (action.type) {
    case ReportsActionTypes.ExportFollowDiscrepanciesUpdate:
    case ProformaActionTypes.ExportGroupUpdate:
      return { ...state, busy: true, message: action.data.message };

    case ReportsActionTypes.ExportPurchaseSummary:
    case ReportsActionTypes.ExportPurchaseSummarySuplier:
    case ReportsActionTypes.GetUploadLinkPort:
      return { ...state, busy: true };

    case ReportsActionTypes.ExportFollowDiscrepanciesFail:
    case ReportsActionTypes.ExportFollowDiscrepanciesSuccess:
    case ProformaActionTypes.ExportGroupSuccess:
    case ProformaActionTypes.ExportGroupUpdate:
    case ReportsActionTypes.ExportPurchaseSummarySuccess:
    case ReportsActionTypes.ExportDiscrepanciesDownload:
    case ReportsActionTypes.UploadProcessSuccess:
    case ReportsActionTypes.UploadFilePortSuccess:
      return { ...state, busy: false, message: null };

    case ReportsActionTypes.UploadFileShippingMarksXlsxProcess:
      let spinnerMessage = "Procesando colores..."  
      return {
        ...state,
        message: spinnerMessage,
        busy: true,
      }
    
    case ReportsActionTypes.UploadFileShippingMarksXlsxProcessSuccess:
      return {
        ...state,
        busy: false,
        message: ''
      }

    case ReportsActionTypes.UploadFileShippingMarksXlsxProcessFail:
      return {
        ...state,
        busy: false,
        message: ''
      }

    default:
      return state;
  }
}

const getState = createFeatureSelector<State>('reports');

export const getIsBusy = createSelector(
  getState,
  (state: State) => state.busy
);

export const getMessage = createSelector(
  getState,
  (state: State) => state.message
);

